import kamala from '../../kamala'
import Message, { setMessageConfig } from './Message'

Message.install = function (Vue, options) {
  setMessageConfig(options)

  if (Message.__installed) {
    // eslint-disable-line
    return
  }

  kamala(Vue)

  Vue.prototype.$message = Message.message
  Vue.prototype.$setMessageConfig = setMessageConfig
  Vue.prototype.$notification = Message.notification
}

export default Message
